module.exports = __webpack_public_path__ + "static/img/webpic002.776a9b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webpic002.jpg
// module id = 5VK7
// module chunks = 1